import React from 'react';
import { Bot } from 'lucide-react';
import { usePlatformKaiOptional } from './PlatformKaiContext';

/**
 * Header Kai launcher — bot icon + label, Patient Portal style green online dot.
 */
export default function KaiHeaderButton({ className = '', showLabel = true }) {
  const kai = usePlatformKaiOptional();

  return (
    <button
      type="button"
      onClick={() => kai?.openKai?.()}
      className={`flex items-center gap-1.5 px-2 py-1.5 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors ${className}`.trim()}
      title="Kai – AI Assistant"
      aria-label="Kai – AI Assistant"
    >
      <span className="relative shrink-0">
        <Bot className="w-5 h-5" />
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-green-500 rounded-full border border-white" aria-hidden />
      </span>
      {showLabel && (
        <span className="hidden sm:inline text-sm font-medium text-gray-700 whitespace-nowrap">
          Kai
        </span>
      )}
    </button>
  );
}
